<div class="credit-check">
  <div *ngIf="displayCreditCheckButton">
    <button id="quoteBtn" class="credit-check-button" mat-flat-button color="accent" type="button" (click)="performCreditCheck()" [disabled]="!CanDoCreditCheck || isCreditCheckInProgress">
      <span class="credit-check-icon" *ngIf="!isCreditCheckInProgress">
        <img src="/assets/icons/icon-money.svg" class="prefix" alt="money-icon" />
      </span>
      <span class="credit-check-spinner" *ngIf="isCreditCheckInProgress">
        <mat-spinner [diameter]="16" color="primary"></mat-spinner>
      </span>
      <span>Credit Check</span>
    </button>
    <p *ngIf="isCreditCheckApproved" class="credit-check-approved">This credit check has been approved manually by {{creditCheckDetails.approvedBy}} on {{formatApprovedDate}}</p>
    <p *ngIf="statusLabel">
      <img [src]="statusLabel?.icon"
           class="icon-sm"
           aria-hidden="false"
           alt="credit-check-icon" />
      {{statusLabel?.displayStatus}}
    </p>
  </div>

  <button *ngIf="isApproveButtonVisible" id="quoteBtn" class="credit-check-button" mat-flat-button color="accent" type="button" (click)="approveCreditCheck()" [disabled]="this.isCreditCheckApproved || isApproveCreditCheckInProgress">
    <span class="credit-check-icon" *ngIf="!isApproveCreditCheckInProgress">
      <img src="/assets/icons/icon-money.svg" class="prefix" alt="money-icon" />
    </span>
    <span class="credit-check-spinner" *ngIf="isApproveCreditCheckInProgress">
      <mat-spinner [diameter]="16" color="primary"></mat-spinner>
    </span>
    <span>Override Credit Check</span>
  </button>

</div>
